/**
 * Calls the `window.print` function but set up as a module so we can mock it
 * in Jest.
 *
 * jest.mock('signer-app/utils/print', () => ({
 *   print: jest.fn(),
 * }));
 */
export const printPage = () => {
  window.print();
};
